import { LiquidSurface } from '@repo/ui/components/liquid-surface';
import { Skeleton } from '@repo/ui/components/skeleton';
import { StatusBadge } from '@repo/ui/components/status-badge';

// The frame, states and badge the Fees & costs and Capital account cards
// share.

export const LIVE_BADGE = <StatusBadge tone="positive">Live</StatusBadge>;

export function SectionShell({
  titleId,
  title,
  note,
  badge,
  children
}: {
  titleId: string;
  title: string;
  note?: string;
  badge?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <LiquidSurface
      type="panel"
      role="region"
      aria-labelledby={titleId}
      className="flex h-full flex-col p-6"
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 id={titleId} className="text-rowa-card text-rowa-text-primary">
          {title}
        </h2>
        {badge}
      </div>
      {note ? (
        <p className="text-rowa-body-sm text-rowa-text-secondary mt-1">
          {note}
        </p>
      ) : null}
      {children}
    </LiquidSurface>
  );
}

export function LoadingBlock() {
  return (
    <div className="mt-5 space-y-3">
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton key={index} className="h-6 w-full" />
      ))}
    </div>
  );
}

export function ErrorBlock() {
  return (
    <p className="text-rowa-body-sm text-rowa-text-secondary mt-5">
      We could not load this section. Retry from the banner above.
    </p>
  );
}
